import { useEffect } from "react";
import Lenis from "lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let lenisInstance = null;

export const getLenis = () => {
  return lenisInstance;
};

function SmoothScroll() {
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (prefersReducedMotion) {
      ScrollTrigger.refresh();

      return undefined;
    }

    const lenis = new Lenis({
      duration: 1.15,
      smoothWheel: true,
      syncTouch: false,
      wheelMultiplier: 0.9,
      touchMultiplier: 1.2,
      infinite: false,
      autoResize: true,
    });

    lenisInstance = lenis;

    const handleLenisScroll = () => {
      ScrollTrigger.update();
    };

    lenis.on("scroll", handleLenisScroll);

    const updateLenis = (time) => {
      lenis.raf(time * 1000);
    };

    gsap.ticker.add(updateLenis);

    gsap.ticker.lagSmoothing(0);

    let resizeTimer = null;
    let orientationTimer = null;
    let refreshTimer = null;

    const refreshScrollTrigger = () => {
      if (refreshTimer) {
        clearTimeout(refreshTimer);
      }

      refreshTimer = setTimeout(() => {
        ScrollTrigger.refresh();
      }, 100);
    };

    const handleWindowLoad = () => {
      refreshScrollTrigger();
    };

    const handleResize = () => {
      if (resizeTimer) {
        clearTimeout(resizeTimer);
      }

      resizeTimer = setTimeout(() => {
        lenis.resize();

        ScrollTrigger.refresh();
      }, 200);
    };

    const handleOrientationChange = () => {
      if (orientationTimer) {
        clearTimeout(orientationTimer);
      }

      orientationTimer = setTimeout(() => {
        lenis.resize();

        ScrollTrigger.refresh();
      }, 300);
    };

    window.addEventListener("load", handleWindowLoad);

    window.addEventListener("resize", handleResize);

    window.addEventListener(
      "orientationchange",
      handleOrientationChange
    );

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => {
        if (lenisInstance === lenis) {
          lenis.resize();

          ScrollTrigger.refresh();
        }
      });
    }

    const initialRefreshTimer = setTimeout(() => {
      lenis.resize();

      ScrollTrigger.refresh();
    }, 150);

    return () => {
      clearTimeout(initialRefreshTimer);

      if (resizeTimer) {
        clearTimeout(resizeTimer);
      }

      if (orientationTimer) {
        clearTimeout(orientationTimer);
      }

      if (refreshTimer) {
        clearTimeout(refreshTimer);
      }

      window.removeEventListener(
        "load",
        handleWindowLoad
      );

      window.removeEventListener(
        "resize",
        handleResize
      );

      window.removeEventListener(
        "orientationchange",
        handleOrientationChange
      );

      lenis.off("scroll", handleLenisScroll);

      gsap.ticker.remove(updateLenis);

      lenis.destroy();

      if (lenisInstance === lenis) {
        lenisInstance = null;
      }
    };
  }, []);

  return null;
}

export default SmoothScroll;